import React, { Component } from "react";
import { Tab, Nav } from "react-bootstrap";
import { connect } from "react-redux";
// import {
// } from "actions";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import TrainingDetailGeneral from "components/widgets/training/TrainingDetailGeneral";
import TrainingDetailRules from "components/widgets/training/TrainingDetailRules";
// import TrainingDetailDocuments from "./TrainingDetailDocuments";
// import ViewTrainingDocument from "components/widgets/training/ViewTrainingDocument";
import { Trans } from "react-i18next";

class TrainingDetailModal extends Component {
  state = {
    trainingDetailFetched: false,
    trainingDetailRules: null,
    trainingDetailDocs: null,
    selectedDocument: null,
    selectedTimeplanId: null,
    currentTab: "general",
  };

  handleTabSelected = (selected) => {
    // console.dir(selected);
    this.setState({ currentTab: selected });
  };

  openViewDocsWithSelectedDocument = (doc) => {
    this.setState({ selectedDocument: doc, currentTab: "viewDocument" });
  };

  handleTimeplanSelected = (tpid) => {
    this.setState({ selectedTimeplanId: tpid });
  };

  renderGeneral = () => {
    return (
      <TrainingDetailGeneral
        id={this.props.training.training.id}
        timeplanId={this.props.training.timeplanId}
        startDate={this.props.training.startDate}
        handleTimeplanSelected={(tpid) => this.handleTimeplanSelected(tpid)}
      />
    );
  };

  renderRules = () => {
    return (
      <TrainingDetailRules
        timeplanId={this.state.selectedTimeplanId}
        training={this.props.training}
      />
    );
  };

  // renderDocs = () => {
  //   return (
  //     <TrainingDetailDocuments
  //       sendToViewerTab={this.openViewDocsWithSelectedDocument}
  //       trainingId={this.props.training.training.id}
  //     />
  //   );
  // };

  // renderViewDocument = () => {
  //   return <ViewTrainingDocument document={this.state.selectedDocument} />;
  // };

  render() {
    return (
      <Tab.Container
        defaultActiveKey="general"
        activeKey={this.state.currentTab}
        onSelect={this.handleTabSelected}
      >
        <Nav variant="tabs" id="egitimModalTab">
          <Nav.Item>
            <Nav.Link eventKey="general">
              <Trans desc="Eğitim Detayı">10389</Trans>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="rules">
              <Trans desc="Katılım Kuralları">10360</Trans>
            </Nav.Link>
          </Nav.Item>
          {/* istek üzerine kapatıldı
          <Nav.Item>
            <Nav.Link eventKey="docs">
              <Trans desc="Dokümanlar">10361</Trans>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="viewDocument">
              <Trans desc="Doküman Görüntüleme">10362</Trans>
            </Nav.Link>
          </Nav.Item> */}
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="general">{this.renderGeneral()}</Tab.Pane>
          <Tab.Pane eventKey="rules">{this.renderRules()}</Tab.Pane>
          {/* istek üzerine kapatıldı
          <Tab.Pane eventKey="docs">{this.renderDocs()}</Tab.Pane>
          <Tab.Pane eventKey="viewDocument">
            {this.renderViewDocument()}
          </Tab.Pane> */}
        </Tab.Content>
      </Tab.Container>
    );
  }
}

export default connect(
  null,
  {}
)(containsLongRunningProcess(TrainingDetailModal));
